import {
  connect,
  editSkill,
  fork,
  get,
  logAssetUsage,
  notifyPayers,
  propose,
  proposeLobby,
  readDeltas,
  refresh,
  remove,
  reportProgress,
  reportRunnerEvent,
  reportTyping,
  searchAssets,
  selectGameMaster,
  startGrader,
  startPlayerAgent,
  stopEval,
  submitScorecard,
} from "./endpoints";

export { AssetMatch, AssetSearchQuery, AssetSearchResponse } from "./assets";
export {
  connect,
  editSkill,
  fork,
  get,
  logAssetUsage,
  notifyPayers,
  propose,
  proposeLobby,
  readDeltas,
  refresh,
  remove,
  reportProgress,
  reportRunnerEvent,
  reportTyping,
  searchAssets,
  selectGameMaster,
  service,
  startGrader,
  startPlayerAgent,
  stopEval,
  submitScorecard,
} from "./endpoints";
export {
  ADMIN_ROLE_ID,
  applyLobbyDelta,
  awaitsApproval,
  type CantPayRule,
  CantPayRuleSchema,
  type Coverer,
  type CoverRunsOutRule,
  CoverRunsOutRuleSchema,
  changesLobbyCopy,
  coveringIds,
  DEFAULT_OFFLINE_LIMIT_RAW,
  EVERYONE_ROLE_ID,
  emptyLobby,
  GamePermission,
  GameRole,
  isOpenToCoop,
  JUMP_TIMER_RANGE_MS,
  type LobbyActor,
  LobbyActorSchema,
  type LobbyChatItem,
  type LobbyDelta,
  LobbyDeltaSchema,
  type LobbyIssue,
  type LobbyIssueCode,
  LobbyIssueCodeSchema,
  LobbyIssueSchema,
  type LobbyMessage,
  type LobbyOperation,
  LobbyOperationSchema,
  type LobbyOperationType,
  type LobbyPoll,
  type LobbyProposal,
  LobbyProposalResult,
  LobbyProposalSchema,
  type LobbyState,
  type LobbySurroundings,
  lobbyCopy,
  lobbyIssue,
  type OfflinePlan,
  OfflinePlanSchema,
  type OfflineRule,
  OfflineRuleSchema,
  offlineLimitOf,
  offlinePlanOf,
  offlinePlansAllowed,
  openPlayAskOf,
  type PaymentMode,
  PaymentModeSchema,
  PERMISSIONS,
  type PlayAnswer,
  PlayAnswerSchema,
  type PlayAsk,
  type PlayAskDropReason,
  PlayAskDropReasonSchema,
  type PlayDestination,
  PlayDestinationSchema,
  permissionsOf,
  rankOf,
  type Shortfall,
  STARTING_ROLES,
} from "./lobby";
export { gamePaths, gameRoutes } from "./paths";
export {
  AgentBrief,
  DeltaRecordQuery,
  DeltaRecordResponse,
  EditSkillRequest,
  EXAMPLES,
  ForkGameRequest,
  ForkGameResponse,
  GameId,
  GameIdParams,
  GameKind,
  GameMasterFailure,
  GameMasterState,
  GameMasterStatus,
  GameSessionSummary,
  GradedPlayer,
  GradingAssignment,
  IdempotencyKey,
  LobbyCommandResponse,
  ModerationRefusal,
  NotifyPayersRequest,
  PlayerConnection,
  PlayerPersona,
  type ProgressKind,
  ProgressKindSchema,
  ProgressRequest,
  type ProgressSubject,
  ProgressSubjectSchema,
  type Proposal,
  ProposalResult,
  ProposalSchema,
  type RecordDelta,
  RecordDeltaSchema,
  RefreshGameResponse,
  ReportRunnerEventRequest,
  ReportRunnerEventResponse,
  Revision,
  RubricSection,
  RunnerLifecycleEvent,
  ScorecardFinding,
  ScorecardSubmission,
  ScoredSection,
  SelectGameMasterRequest,
  SkillEdit,
  StartedAgent,
  StartGraderRequest,
  StartPlayerAgentRequest,
  Timestamp,
  TypingRequest,
  UserId,
} from "./schemas";
export {
  type AiAccess,
  AiAccessSchema,
  type AuthenticateFrame,
  AuthenticateFrameSchema,
  type ClientFrame,
  ClientFrameSchema,
  type Endpoints,
  GameEndpointsSchema,
  HEARTBEAT,
  HEARTBEAT_INTERVAL_MS,
  HEARTBEAT_SILENCE_MS,
  type PayerSignal,
  type PlayAskSummary,
  PlayAskSummarySchema,
  type Role,
  RoleSchema,
  type ServerFrame,
  type ServerFrameOf,
  ServerFrameSchema,
  type SessionMember,
  SessionMemberSchema,
  type SessionSkill,
  SessionSkillSchema,
  type ShutdownReason,
  ShutdownReasonSchema,
  socket,
  socketProtocol,
  type TelemetrySignal,
  TelemetrySignalSchema,
  TraceparentSchema,
  TYPING_EXPIRES_MS,
  TYPING_IDLE_MS,
  TYPING_REFRESH_MS,
  type TypingFrame,
  TypingFrameSchema,
} from "./socket";
export { type Submission, type SubmitOutcome, submit } from "./submit";

export const contract = {
  propose,
  proposeLobby,
  reportProgress,
  reportTyping,
  stopEval,
  connect,
  editSkill,
  selectGameMaster,
  fork,
  remove,
  notifyPayers,
  refresh,
  get,
  reportRunnerEvent,
  readDeltas,
  startGrader,
  submitScorecard,
  searchAssets,
  logAssetUsage,
  startPlayerAgent,
} as const;
